import { ChevronRight, LucideIcon } from 'lucide-react';

interface OptionCardProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  onClick: () => void;
}

export const OptionCard = ({ icon: Icon, title, subtitle, onClick }: OptionCardProps) => {
  return (
    <button
      onClick={onClick}
      className="w-full bg-white rounded-[16px] border border-[#E5E7EB] p-4 hover:border-[#FF6A2A] hover:shadow-md transition-all group"
    >
      <div className="flex items-start gap-3">
        <div className="w-12 h-12 bg-[#FFF4ED] rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-[#FF6A2A] transition-colors">
          <Icon className="w-6 h-6 text-[#FF6A2A] group-hover:text-white transition-colors" />
        </div>
        <div className="flex-1 text-left">
          <p className="font-semibold text-[#111827] mb-1">{title}</p>
          <p className="text-sm text-[#6B7280]">{subtitle}</p>
        </div>
        <ChevronRight className="w-5 h-5 text-[#6B7280] group-hover:text-[#FF6A2A] transition-colors flex-shrink-0 mt-1" />
      </div>
    </button>
  );
};
